import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { I18nContext } from '@bingads-webui-react/i18n-context';

export const StepHeader = ({
  title,
  description,
}) => {
  const i18n = useContext(I18nContext);

  return (
    <React.Fragment>
      <h2 className="step-title">
        {i18n.getString(title)}
      </h2>
      {description &&
        <p className="step-description">
          {i18n.getString(description)}
        </p>
      }
    </React.Fragment>
  );
};

StepHeader.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};
